import { TFunction } from "i18next"
import { SchoolGroupSubscriptionFragment } from "@pathwright/graphql-client/src/generated"
import getStripePaymentPortalHref from "../stripe/utils/getStripePaymentPortalHref"
import { getIsSubscriptionUsable } from "../subscription/utils"
import {
  MENTOR_GROUP_MEMBERSHIP_ROLE_ADMIN,
  MENTOR_GROUP_MEMBERSHIP_ROLE_MEMBER,
  MENTOR_GROUP_MEMBERSHIP_ROLE_MODERATOR
} from "./constants"

export const getCommunityGroupRoleLabel = (
  role: number,
  translator: TFunction
) => {
  switch (role) {
    case MENTOR_GROUP_MEMBERSHIP_ROLE_MEMBER:
      return translator("member")
    case MENTOR_GROUP_MEMBERSHIP_ROLE_MODERATOR:
      return translator("mentor")
    case MENTOR_GROUP_MEMBERSHIP_ROLE_ADMIN:
      return translator("group admin")
  }
}

// Get the appropriate link props for the group subscription
// based on whether the subscription is usable.
export function getGroupSubscriptionLinkProps(
  groupSubscription: SchoolGroupSubscriptionFragment
) {
  const isSubscriptionUsable = getIsSubscriptionUsable(
    groupSubscription?.subscription
  )
  // Attempt to determine if the user can manage the subscription.
  // May be poor UX to route user to /subscribe flow when we cannot determine
  // that they can manage the subscription (but same could be said of the opposite, to
  // route them to the Stripe payment portal when they cannot manage the subscription),
  // but currently all use cases of getGroupSubscriptionLinkProps are successfully
  // passing in the groupSubscription, so we should be correctly determining this.
  const canManage =
    !!groupSubscription?.community_group?.permissions?.can_edit_subscription

  return isSubscriptionUsable && canManage
    ? {
        href: getStripePaymentPortalHref(),
        target: "_blank"
      }
    : {
        to: "/subscribe/"
      }
}
